import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@constants/api.constant';
import { ListModel, ReadFilterResponse, SongModel, SongsFilterObject } from '@models/music.model';

@Injectable({
	providedIn: 'root'
})
export class MusicService {
	private http = inject(HttpClient);
    // Sostituita con la readFilteredSongs
    // getSongs() {
    //     return this.http.get<SongModel[]>(
    //         API_URL.getSong,
    //         { responseType: 'json' }
    //     )
    // }


    getLists() {
        return this.http.get<ListModel>(
            API_URL.getLists,
            { responseType: 'json' }
        )
    }


    readFilteredSongs(filters:SongsFilterObject) {
        return this.http.post<ReadFilterResponse>(
            API_URL.readFilteredSong,
            filters,
            { responseType: 'json' }
        )
    }



    getMusic(fileName:string) {
        return this.http.get<string>(
            `${API_URL.getMusicUrl}/${fileName}`,
            { responseType: 'text' as 'json' }
        )
    }

    updateSong(songData:SongModel) {
        return this.http.post<any>(
            API_URL.updateSong,
            songData ,
            {   
                headers: {
                    'X-Loader-Message': 'Sto aggiornando i dati...'
                },
                responseType: 'json'
            }
        )
    }

    createSong(newSongData:FormData) {
        return this.http.post<SongModel>(
            API_URL.createSong,
            newSongData ,
            {   
                headers: {
                    'X-Loader-Message': 'Sto creando i dati...'
                },
                responseType: 'json'
            }
        )
    }
    

    deleteSong(songId:string) {
        return this.http.request<string>(
            'DELETE',
            `${API_URL.deleteSong}/${songId}`,
            { 
                headers: {
                    'X-Loader-Message': 'Sto cancellando i dati...'
                },
                responseType: 'text' as 'json'
            }
        )
    }
}
